
// You can write more code here

/* START OF COMPILED CODE */

import EntityRelic from "../EntityRelic";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class RelicWings extends EntityRelic {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 74, y ?? 47);

    // boots
    const wings = scene.add.image(0, 0, 'game-all', 'relic-wings.png');
    wings.scaleX = 0.5;
    wings.scaleY = 0.5;
    this.add(wings);

    this.wings = wings;

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  private wings: Phaser.GameObjects.Image;

  /* START-USER-CODE */

  protected injectMatter(target: Phaser.GameObjects.GameObject) {
    this.setSize(this.wings.displayWidth, this.wings.displayHeight);

    super.injectMatter(target);
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
